// extracted by mini-css-extract-plugin
export default {"trigger":"Tooltip_trigger__vVVJp","bubble":"Tooltip_bubble__bhbJA","tooltip-in":"Tooltip_tooltip-in__ZvpUB","top":"Tooltip_top__T2Nkl","bottom":"Tooltip_bottom__o29kb"};